import { List, ValueEncoder } from 'DiscoveryEngine.TS/Utils';
import { ObjectSerializer, ObjSerUtils } from 'DiscoveryEngine.TS/Serialization';


export enum ADAuthType {
	Windows,
	LDAP,
}


export class ActiveDirectorySettingsDto implements ObjectSerializer {

	private static readonly Default_Enabled: boolean = false;
	private static readonly Default_QueryPageSize: number = 50;
	private static readonly Default_AutoSyncDirectoryData_Enabled: boolean = false;
	private static readonly Default_AuthType: ADAuthType = ADAuthType.Windows;
	private static readonly Default_UseSSL: boolean = false;
	public static readonly Default_ADServerPort_NoSsl = 389;
	public static readonly Default_ADServerPort_Ssl = 636;
	private static readonly Default_AllowLdapReferrals: boolean = false;

	public Enabled: boolean;
	public DomainNames: List<string>;
	public QueryPageSize: number;
	public AutoSyncDirectoryData_Enabled: boolean;
	public AutoSyncDirectoryData_Days: number;
	public AutoSyncDirectoryData_Hours: number;
	public AutoSyncDirectoryData_Minutes: number;
	public AuthType: ADAuthType;
	public ADServerHostIp: string;
	public ADServerPort: number;
	public UseSSL: boolean;
	public AllowLdapReferrals: boolean;

	constructor() {
		this.Enabled = ActiveDirectorySettingsDto.Default_Enabled;
		this.DomainNames = new List<string>();
		this.QueryPageSize = ActiveDirectorySettingsDto.Default_QueryPageSize;
		this.AutoSyncDirectoryData_Enabled = ActiveDirectorySettingsDto.Default_AutoSyncDirectoryData_Enabled;
		this.AutoSyncDirectoryData_Days = 0;
		this.AutoSyncDirectoryData_Hours = 0;
		this.AutoSyncDirectoryData_Minutes = 0;
		this.AuthType = ActiveDirectorySettingsDto.Default_AuthType;
		this.ADServerHostIp = "";
		this.ADServerPort = ActiveDirectorySettingsDto.Default_ADServerPort_NoSsl;
		this.UseSSL = ActiveDirectorySettingsDto.Default_UseSSL;
		this.AllowLdapReferrals = ActiveDirectorySettingsDto.Default_AllowLdapReferrals;
	}

	public get HasDomainNames(): boolean {
		return (!!this.DomainNames && this.DomainNames.Count > 0);
	}

	public get HasADServerHostIp(): boolean {
		return !!this.ADServerHostIp;
	}

	public get HasADServerPort(): boolean {
		return (this.ADServerPort > 0);
	}

	public Write(obj: any, context: any): void {

		obj.active_directory_settings = {};
		obj = obj.active_directory_settings;

		obj.enabled = ValueEncoder.EncodeBoolean(this.Enabled);

		if (this.HasDomainNames) {
			obj.domain_names = [];
			ObjSerUtils.WriteStringValueCollection(obj.domain_names, this.DomainNames, context);
		}

		obj.query_page_size = ValueEncoder.EncodeInteger(this.QueryPageSize);
		obj.auto_sync_directory_data_enabled = ValueEncoder.EncodeBoolean(this.AutoSyncDirectoryData_Enabled);
		obj.auto_sync_directory_data_days = ValueEncoder.EncodeInteger(this.AutoSyncDirectoryData_Days);
		obj.auto_sync_directory_data_hours = ValueEncoder.EncodeInteger(this.AutoSyncDirectoryData_Hours);
		obj.auto_sync_directory_data_minutes = ValueEncoder.EncodeInteger(this.AutoSyncDirectoryData_Minutes);
		obj.auth_type = ADAuthType[this.AuthType];

		if (this.HasADServerHostIp) {
			obj.ad_server_host_ip = this.ADServerHostIp;
		}

		obj.ad_server_port = ValueEncoder.EncodeInteger(this.ADServerPort);
		obj.use_ssl = ValueEncoder.EncodeBoolean(this.UseSSL);
		obj.allow_ldap_referrals = ValueEncoder.EncodeBoolean(this.AllowLdapReferrals);
	}

	public Read(obj: any, context: any): void {

		if (!obj.active_directory_settings)
			throw new Error();
		obj = obj.active_directory_settings;

		if (obj.enabled !== undefined) {
			this.Enabled = ValueEncoder.DecodeBoolean(obj.enabled);
		}

		if (obj.domain_names !== undefined) {
			ObjSerUtils.ReadStringValueCollection(obj.domain_names, this.DomainNames, context);
		}

		if (obj.query_page_size !== undefined) {
			this.QueryPageSize = ValueEncoder.DecodeInteger(obj.query_page_size);
		}

		if (obj.auto_sync_directory_data_enabled !== undefined) {
			this.AutoSyncDirectoryData_Enabled = ValueEncoder.DecodeBoolean(obj.auto_sync_directory_data_enabled);
		}

		if (obj.auto_sync_directory_data_days !== undefined) {
			this.AutoSyncDirectoryData_Days = ValueEncoder.DecodeInteger(obj.auto_sync_directory_data_days);
		}

		if (obj.auto_sync_directory_data_hours !== undefined) {
			this.AutoSyncDirectoryData_Hours = ValueEncoder.DecodeInteger(obj.auto_sync_directory_data_hours);
		}

		if (obj.auto_sync_directory_data_minutes !== undefined) {
			this.AutoSyncDirectoryData_Minutes = ValueEncoder.DecodeInteger(obj.auto_sync_directory_data_minutes);
		}

		if (obj.auth_type !== undefined) {
			this.AuthType = ADAuthType[<string>obj.auth_type];
		}

		if (obj.ad_server_host_ip !== undefined) {
			this.ADServerHostIp = obj.ad_server_host_ip;
		}

		if (obj.ad_server_port !== undefined) {
			this.ADServerPort = ValueEncoder.DecodeInteger(obj.ad_server_port);
		}

		if (obj.use_ssl !== undefined) {
			this.UseSSL = ValueEncoder.DecodeBoolean(obj.use_ssl);
		}

		if (obj.allow_ldap_referrals !== undefined) {
			this.AllowLdapReferrals = ValueEncoder.DecodeBoolean(obj.allow_ldap_referrals);
		}
	}

}
